import { getEnvConfig } from "env";
import config from "../config";
import { ComponentUnit } from "../types";
import { useScadaPlusQuery } from "./useScadaPlusQuery";

export const useGetComponentUnits = (plantId: string, sectionId?: string) => {
  const constructQueryUrl = () => {
    if (sectionId) {
      return `${getEnvConfig("API_URL")}/api/${config.api.componentUnit}?sectionId=${sectionId}`;
    }
    return `${getEnvConfig("API_URL")}/api/${config.api.componentUnit}?plantId=${plantId}`;
  };

  return useScadaPlusQuery<Array<ComponentUnit>>(
    `componentUnits-${plantId}-${sectionId}`,
    constructQueryUrl(),
  );
};

export const useGetComponentUnit = (componentUnitId: string) => {
  const constructQueryUrl = () => {
    return `${getEnvConfig("API_URL")}/api/${config.api.componentUnit}?componentUnitId=${componentUnitId}`;
  };

  return useScadaPlusQuery<Array<ComponentUnit>>(
    `componentUnit-${componentUnitId}`,
    constructQueryUrl(),
  );
};
